import { useMutation } from "react-query";
import { UserManagePayload } from "./interfaces";
import { ApiContext } from "../contexts/ApiContext";
import { useContext } from "react";

export function useCreateUser() {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationFn: async (newUser: UserManagePayload) => {
      try {
        return await apiContext.accountApis.createUser(newUser);
      } catch (error: unknown) {
        if (error instanceof Response) {
          const errorMessage = await error.text();

          throw new Error(errorMessage);
        }
        throw new Error("Error in creating user");
      }
    },
  });
}
